import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=11c55d80&"
import script from "./FieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./FieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports